export default {
    methods: {
        filterUrl(url) {
            url = url ? url : '';
            const protocol = /https?:\/\//g;
            return url.replace(protocol, "")
        }
    }
}
